import { render, staticRenderFns } from "./LdGatedContent.vue?vue&type=template&id=2dc610f6"
import script from "./LdGatedContent.vue?vue&type=script&lang=js"
export * from "./LdGatedContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports